import React from 'react';
import styles from './BannerSwiper.module.css';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
import 'swiper/modules/navigation/navigation.min.css'
import 'swiper/modules/pagination/pagination.min.css'

interface Props {
  bannerList: any[];
  vendorId: any;
  publishSource: string;
  onClickBanner?: (index: number) => void;
}

let timer:any = null;
let exposedIndex: number[] = [];

const BannerSwiper:React.FC<Props> = (props: Props) => {

  const onSlideChange = (swiper: any) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      let activeIndex = Math.max(swiper.activeIndex - 1, 0);
      if (activeIndex >= props.bannerList.length) {
        activeIndex = activeIndex - props.bannerList.length;
      }
      // 避免重复曝光
      if (exposedIndex.includes(activeIndex)) return
      const activeItem = props.bannerList[activeIndex] || {};
      if ((window as any).expLogJSON) {
        const params = {
          'action_source': '' + props.publishSource,
          'venderid': '' + props.vendorId,
          'frame': '' + activeIndex,
          'activity_url': activeItem.linkUrl
        };
        (window as any).expLogJSON('auction', 'NewShop_banner_expo', JSON.stringify(params));
      }
      exposedIndex.push(activeIndex)
    }, 500)
  }


  const handleClickSwiper = (item: any, index: any) => {
    const params = {
      'action_source': '' + props.publishSource,
      'venderid': '' + props.vendorId,
      'frame': '' + index,
      'activity_url': item.linkUrl
    };
    (window as any).log(
      'auction',
      'NewShop_banner',
      JSON.stringify(params)
    );
    setTimeout(() => {
      window.open(item.linkUrl, '_blank');
    }, 100)
  }



  return (
    <div className={styles.bannerWrapper}>
      <Swiper
        modules={[Pagination, Autoplay]} 
        className={styles.bannerSwiper}
        spaceBetween={10}
        slidesPerView={1}
        autoplay={props.bannerList && props.bannerList.length > 1 ? {
          disableOnInteraction: false, 
          delay: 3000,
        } : false}
        loop={props.bannerList && props.bannerList.length > 1 ? true : false}
        runCallbacksOnInit={false}
        pagination={{ 
          clickable: true,  
          bulletClass: `swiper-pagination-bullet ${styles.bullet}`,
          bulletActiveClass: styles.bulletActive
      }}
        onSlideChange={onSlideChange}
        onInit={onSlideChange}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {props.bannerList && props.bannerList.map((item, index) => {
          return  (
            <SwiperSlide key={index} onClick={() => handleClickSwiper(item, index)}>
              <img src={item.imgUrl} alt="" className={styles.swiperItem}/>
          </SwiperSlide>
          )
        })}


      </Swiper>
      <div ></div>
    </div>

  )
}


export default BannerSwiper;